import { SearchBox,TooltipHost } from "@fluentui/react";
import { BackIcon } from "@fluentui/react-icons-mdl2";
import React,{useState,useContext, useEffect,useRef} from "react";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import { t } from "i18next";
import themeContext from "../../../../context/theme/ThemeContext";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";

const TemplateList = (props)=>{
  const isStudyList = true;
  const { getAlterColor } = useContext(themeContext);
    const {
        dropdownSelectedTemplates,setDropdownSelectedTemplates,
        dropdownSelectedTemplatesStore, setDropdownSelectedTemplatesStore
        ,handleDropdownWithContext, selectedCategoryTemplate, setActiveTab
      } = useContext(studyReportContext);
  const {getThemeColor} = useContext(themeContext);

    const searchBoxRef = useRef(null);
  
    const [overflowState, setOverflowState] = useState({});

    const checkOverflow = () => {
      const newOverflowState = {};
      dropdownSelectedTemplates.forEach((report) => {
        const textElement = document.getElementById(`reportTemplateListText_${report.key}`);
        if (textElement) {
          newOverflowState[report.key] = textElement.scrollWidth > textElement.clientWidth;
        }
      });
      setOverflowState(newOverflowState);
    };

    useEffect(() => {
      checkOverflow();
    }, [dropdownSelectedTemplates]);


    const searchStyle = {
        root: { width:'185px'},
      };

    useEffect(()=>{
      setDropdownSelectedTemplates(dropdownSelectedTemplatesStore);
      console.log(searchBoxRef)
      if (searchBoxRef.current) {
        searchBoxRef.current.focus();
      }
    },[])



    const filterList = (searchInput) => {
      if(searchInput != null && searchInput != undefined)searchInput = searchInput.trim();
        let searchValue = searchInput;
        let allTemp = dropdownSelectedTemplatesStore;
        if (searchValue != "") {
        const filteredData = allTemp.filter((item) => {
            let str = item.text.toLowerCase();
            return str.includes(searchValue.toLowerCase());
        });
            setDropdownSelectedTemplates(filteredData);
        } else {
            setDropdownSelectedTemplates(dropdownSelectedTemplatesStore);
        }
      };

   return (
    <>
     <div className="report-options" style={{ background: isStudyList ? getThemeColor("report-template-container") : "#201F1E"}}>
            <div style={{ display: "flex",flexDirection:"column" }}>
                {/* <div className="back-button" onClick={props.handleBackClick}>
                    <BackIcon/>
                    <span style={{color: getAlterColor("#a19f9d","#000")}} className="back-button-text">{t("button.back")}</span>
                </div> */}
              <div style={{ width: "230px", display: "flex", justifyContent: "space-between" }}>
                <SearchBox
                  ref={searchBoxRef}
                  placeholder={t("button.search")}
                  styles={searchStyle}
                  autoFocus={true}
                  onClear={(ev) => {
                    console.log("Custom onClear Called");
                  }}
                  onChange={(ev, newValue) => {filterList(newValue);}}
                />
              </div>
            </div>
            <ul className="dropdown-menu-report scrollable-menu modal-scroll-annotation">
               {dropdownSelectedTemplates.length > 0 ? (
                dropdownSelectedTemplates.map((report, index) => {
                  return (
                    <li
                    className={`${report.reportDetails.active ? "no-style" : "no-style-disabled"}`}
                    style={{minHeight:'20px'}}
                      key={report.key}
                      onClick={() => {
                        if(!report.reportDetails.active) return;
                        if(selectedCategoryTemplate === "dsrTemplate") setActiveTab(3);
                        else setActiveTab(1);
                        handleDropdownWithContext(report,props.rsnaFlag);
                        props.onClickOutside();
    
                        //addOrRemoveAnnotation(pathology.id,1);
                        //props.setShowInfo1(false);
                      }}
                    >
                      <a style={{color: getAlterColor("#a19f9d","#000")}} className="viewer-template-a" id={report.id}>
                        
                      {overflowState[report.key]  ? (
                          <CustomToolTipHost content={report.text} id={"tooltip_"}>
                            <span id={`reportTemplateListText_${report.key}`}  className="viewer-li-text">{report.text}</span>
                          </CustomToolTipHost>
                        ) : (
                          <span id={`reportTemplateListText_${report.key}`}  className="viewer-li-text">{report.text}</span>
                        )}
                        </a>
                    </li>
                  );
                })
              ) : (
                
                <li key="0" className="no-result">
                  <a>{t("search-message.no-result")}</a>
                </li>
              )} 
            </ul>
          </div>
    </>
   )
}

export default TemplateList;